import React from 'react';

function FullListIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.35 2.49999H15.8333C16.75 2.49999 17.5 3.24999 17.5 4.16666V17.5C17.5 18.4167 16.75 19.1667 15.8333 19.1667H4.16667C3.25 19.1667 2.5 18.4167 2.5 17.5V4.16666C2.5 3.24999 3.25 2.49999 4.16667 2.49999H7.65C8 1.53333 8.91667 0.833328 10 0.833328C11.0833 0.833328 12 1.53333 12.35 2.49999ZM4.16667 16.6667C4.16667 17.125 4.54167 17.5 5 17.5H15C15.4583 17.5 15.8333 17.125 15.8333 16.6667V4.99999C15.8333 4.54166 15.4583 4.16666 15 4.16666H14.1667V4.99999C14.1667 5.91666 13.4167 6.66666 12.5 6.66666H7.5C6.58333 6.66666 5.83333 5.91666 5.83333 4.99999V4.16666H5C4.54167 4.16666 4.16667 4.54166 4.16667 4.99999V16.6667ZM12.6667 11.6667H7.33333C7.33333 11.6667 6.66667 11.6667 6.66667 12.5C6.66667 13.3333 7.33333 13.3333 7.33333 13.3333H12.6667C12.6667 13.3333 13.3333 13.3333 13.3333 12.5C13.3333 11.6667 12.6667 11.6667 12.6667 11.6667ZM6.66667 8.33333H13.3333C13.3333 8.33333 14.1667 8.33333 14.1667 9.16666C14.1667 9.99999 13.3333 9.99999 13.3333 9.99999H6.66667C6.66667 9.99999 5.83333 9.99999 5.83333 9.16666C5.83333 8.33333 6.66667 8.33333 6.66667 8.33333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default FullListIcon;
